module.exports = __webpack_public_path__ + "img/4-2-south-2.c5171db8.jpg";